import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';

import { appendClassName } from '../../../../lib/bemUtils/classname';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { LiProps } from '../../../../types/HtmlProps';

export enum ContentListItemModifier {
  BORDER_LEFT = 'border-left',
  BORDER_TOP = 'border-top',
  PADDING_15_TOP_BOTTOM = 'padding-15-top-bottom',
  DRAGGING = 'dragging',
  NO_PADDING = 'no-padding',
  NO_PADDING_VERTICAL = 'no-padding-vertical',
  PADDING_5 = 'padding-5',
}

export type ContentListItemProps = LiProps & {
  modifier?: Modifier<ContentListItemModifier>;
  setFocus?: boolean;
  ref?: React.RefObject<HTMLLIElement | null>;
};

export function ContentListItem({
  children,
  modifier,
  className,
  ref,
  ...props
}: PropsWithChildren<ContentListItemProps>) {
  return (
    <li className={appendClassName(className, bem('content-list__item', modifier))} {...props} ref={ref}>
      {children}
    </li>
  );
}
